import React, {useEffect} from 'react';
import Decorazione1 from '../components/decorazioni/1decorazione';
import Decorazione2 from '../components/decorazioni/2decorazione';
import Vino from '../components/vino';
import dati from '../dati/ViniDati.json';
import L30Foto from '../immaginiDino/vinoImg/vino1.png';
import EvOliva from '../immaginiDino/olioImg/EvOliva.png'
function Olio(){
    
    const olio = dati.EvOliva;
    useEffect(() => {
        document.title = "Olio - Cantina Testacalla";
    }, []);
    
    return(
    <>
    <div className='flex flex-col gap-[5rem] pt-[100px] pb-[50px]' >
    <Vino foto={EvOliva} nome={olio.titolo} descrizione=

        "L'uliveto 'Testacalla' è un piccolo apprezzamento di terreno composto da 1000 piante di tre qualità diverse di olive: MORAIOLO = pianta autoctona, LECCINO e FRANTOIO = piante nazionali. La combinazione di queste olive permette di ottenere un OLIO di ALTA QUALITA' dal profumo e gusto fragrante. La qualità migliore, anche se la resa è minore, si ottiene raccogliendo le olive l'ultima decina del mese di ottobre, quando cioè esse sono appena maturate. L'olio prodotto è di tipo biologico, il prodotto portato in tavola è genuino, puro, può essere per questo utilizzato anche nelle praparazioni dei pasti per i bambini. Le olive, infatti, non vengono trattate con insetticidi."

        link={olio.link} colore={olio.colore} testo={olio.testo} vendita={'Disponibile per la vendita in bottiglie da 0,50 lt e 0,75 lt. o in taniche da 3lt. e 5lt '}/>

    </div>
        <div className="h-[200px]"></div>
    </>
    )
};
export default Olio;